import xamatron from "xamatron";
import AiRoot from "components/AiRoot";
xamatron.ready(function () {
    new AiRoot().$mount("#root");
});
